import { qAActionTypes } from './Constants';

export function getQAOverview(data) {
	return {
		type: qAActionTypes.GET_QA_OVERVIEW,
		payload: { data },
	};
}

export function getQAOverviewSuccess(data) {
	return {
		type: qAActionTypes.GET_QA_OVERVIEW_SUCCESS,
		payload: { data },
	};
}

export function getQAOverviewError() {
	return {
		type: qAActionTypes.GET_QA_OVERVIEW_ERROR,
	};
}

export function changeFilters(data) {
	return {
		type: qAActionTypes.CHANGE_FILTERS,
		payload: { data },
	};
}

export function getMyQuestions(data) {
	return {
		type: qAActionTypes.GET_MY_QUESTIONS,
		payload: { data },
	};
}

export function getMyQuestionsSuccess(data) {
	return {
		type: qAActionTypes.GET_MY_QUESTIONS_SUCCESS,
		payload: { data },
	};
}

export function getMyQuestionsError() {
	return {
		type: qAActionTypes.GET_MY_QUESTIONS_ERROR,
	};
}

export function getMyAnswers(data) {
	return {
		type: qAActionTypes.GET_MY_ANSWERS,
		payload: { data },
	};
}

export function getMyAnswersSuccess(data) {
	return {
		type: qAActionTypes.GET_MY_ANSWERS_SUCCESS,
		payload: { data },
	};
}

export function getMyAnswersError() {
	return {
		type: qAActionTypes.GET_MY_ANSWERS_ERROR,
	};
}

export function getRanks() {
	return {
		type: qAActionTypes.GET_HIW_RANKS,
	};
}

export function getRanksSuccess(data) {
	return {
		type: qAActionTypes.GET_HIW_RANKS_SUCCESS,
		payload: { data },
	};
}

export function getRanksError() {
	return {
		type: qAActionTypes.GET_HIW_RANKS_ERROR,
	};
}

export function getQuestionDetails(data) {
	return {
		type: qAActionTypes.GET_QUESTION_DETAILS,
		payload: { data },
	};
}

export function getQuestionDetailsSuccess(data) {
	return {
		type: qAActionTypes.GET_QUESTION_DETAILS_SUCCESS,
		payload: { data },
	};
}

export function getQuestionDetailsError() {
	return {
		type: qAActionTypes.GET_QUESTION_DETAILS_ERROR,
	};
}

export function getRelatedQuestions(data) {
	return {
		type: qAActionTypes.GET_RELATED_QUESTION,
		payload: { data },
	};
}

export function getRelatedQuestionsSuccess(data) {
	return {
		type: qAActionTypes.GET_RELATED_QUESTION_SUCCESS,
		payload: { data },
	};
}

export function getRelatedQuestionsError() {
	return {
		type: qAActionTypes.GET_RELATED_QUESTION_ERROR,
	};
}

export function upvoteAnswer(data) {
	return {
		type: qAActionTypes.UPVOTE_ANSWER,
		payload: { data },
	};
}

export function clearQuestionDetails() {
	return {
		type: qAActionTypes.CLEAR_QUESTION_DETAILS,
	};
}

export function cleanQuestionState() {
	return {
		type: qAActionTypes.CLEAN_QUESTION_STATE,
	};
}

export function cleanQAState() {
	return {
		type: qAActionTypes.CLEAN_QA_STATE,
	};
}

export function setIsDeletedQuestion() {
	return {
		type: qAActionTypes.SET_IS_DELETED_QUESTION,
	};
}
